import axios from "axios"

const http = axios.create({
    baseURL: "http://192.168.1.12:3011/api",
})


export default http